// @ts-strict-ignore
import {DrawComponentActionShape, DrawComponentState} from './draw-component';
import Konva from 'konva';
import {PathDrawComponent} from './path-draw-component';

export class DrawComponentArrow extends PathDrawComponent {

    readonly transformerAnchors = ['bottom-right'];
    readonly drawingShapeDefaultConfig = {
        hitStrokeWidth: 30,
        points: [0, 0, 150, 0],
    };
    readonly drawingShape: Konva.Arrow;

    constructor(
        uuid: string,
        state: DrawComponentState,
    ) {
        super(uuid, DrawComponentActionShape.ARROW, state);

        this.drawingShape = new Konva.Arrow({...this.drawingShapeDefaultConfig, ...state.config});
        this.drawingLayer.add(this.drawingShape);

        this.addDraggablePoints();
        this.draw();
    }

    updateState() {
        super.updateState();

        this.state.config.points = this.drawingShape.points();
    }

}
